import { Dispatch, SetStateAction } from "react";
import TextField from "@mui/material/TextField";
import CloseIcon from "@mui/icons-material/Close";
import StarIcon from "@mui/icons-material/Star";
import { Modal, Button } from "@mui/material";

interface ModalProps {
    open: boolean;
    onClose: () => void;
    setOpen: Dispatch<SetStateAction<boolean>>;
}

export default function AddRatingReply({ open, onClose, setOpen }: ModalProps) {
    return (
        <Modal className="modal addReply_modal" open={open} onClose={onClose}>
            <div className="modal-dialog">
                <div className="modal-body">
                    {/* Title Bar */}
                    <div className="modal_title">
                        <h2>Add Reply</h2>
                        <button
                            type="button"
                            className="btn-close"
                            onClick={() => setOpen(false)}
                        >
                            <CloseIcon />
                        </button>
                    </div>

                    {/* Rating & Review Section */}
                    <div className="view_page gap_p">
                        <div className="w_100">
                            <h6>Rating</h6>
                            <p>
                                5 <StarIcon sx={{ color: "#FFC107", fontSize: 18 }} />
                            </p>
                        </div>

                        <div className="w_100">
                            <h6>Review</h6>
                            <p>
                                Lorem ipsum dolor sit amet, consectetur adipisicing elit. Nemo,
                                animi consequatur consectetur adipisicing elit.
                            </p>
                        </div>
                    </div>

                    {/* Reply Section */}
                    <form className="form" action="">
                        <div className="control_group">
                            <label>Add Reply</label>
                            <TextField
                                placeholder="Enter Reply"
                                fullWidth
                                hiddenLabel
                                multiline
                                minRows={4}
                            />
                        </div>

                        {/* Footer Buttons */}
                        <div className="footer_btn_flex">
                            <Button className="btn btn_primary" onClick={() => setOpen(false)}>
                                Submit
                            </Button>
                        </div>
                    </form>
                </div>
            </div>
        </Modal>
    );
}